$(function () {
  // Hide Mobile subNav trigger if subnav is empty
  if (
    !$("#subNavWrapper #subNavContainer .subNav li").first().children().length
  ) {
    $(".subNavTrigger").addClass("hide");
  } else {
    $(".subNavTrigger").removeClass("hide");
  }

  // Mobile subNav open/close
  $(".subNavTrigger").on("click", function () {
    $(this).attr(
      "aria-expanded",
      $(this).attr("aria-expanded") === "false" ? "true" : "false"
    );
    $("#subNavWrapper").slideToggle();
  });

  $("#subNavWrapper")
    .find(".toggle")
    .each(function (index) {
      let ddId = "subNavDropdown-" + index;

      if ($(this).next("ul").attr("id")) {
        ddId = $(this).next("ul").attr("id");
      } else if ($(this).hasClass("extendedToggle")) {
        ddId = "extendedMenu";
      } else {
        ddId = "subNavDropdown-" + index;
      }

      $(this).attr("aria-controls", ddId).next("ul").attr("id", ddId);
    });

  // SUBNAV NAV TRAP FOCUS
  $(function () {
    const $subNavTrigger = $("#pageHeading .subNavTrigger"),
      $subNav = $("#subNavContainer");

    $subNavTrigger.on("click", function () {
      let isExpanded = $(this).attr("aria-expanded") === "true" ? true : false;

      !isExpanded
        ? remove_trap_focus($subNav, "subNavTrap")
        : trap_focus($subNav, "subNavTrap");
    });
  });

  // Subnav Extended Menu Toggle
  $("#subNavWrapper .extendedMenuWrapper").on(
    "click",
    "a.extendedMenu, > .toggle",
    function (event) {
      event.preventDefault();

      $(
        '#subNavWrapper .extendedMenuWrapper > [aria-controls="extendedMenu"]'
      ).attr(
        "aria-expanded",
        $(this).attr("aria-expanded") === "false" ? "true" : "false"
      );

      //show/hide menu items
      $("#subNavContainer ul#extendedMenu").slideToggle();

      //change button text to Close or View and add/remove class to control toggle
      if ($('#subNavContainer a.extendedMenu:contains("Close")').length > 0) {
        $("#subNavContainer a.extendedMenu")
          .removeClass("open")
          .find("span")
          .text(function (index, text) {
            return text.replace("Close", "View");
          });
      } else {
        $("#subNavContainer a.extendedMenu")
          .addClass("open")
          .find("span")
          .text(function (index, text) {
            return text.replace("View", "Close");
          });
      }

      $(".extendedMenuWrapper > .toggle")
        .parent("div")
        .next("ul")
        .parent("li")
        .toggleClass("open");
    }
  );

  // Subnav Menu Toggle Click
  $(".subNav").on("click", ".toggle:not(.extendedToggle)", function (event) {
    event.preventDefault();
    event.stopPropagation();

    $(this)
      .attr(
        "aria-expanded",
        $(this).attr("aria-expanded") === "false" ? "true" : "false"
      )
      .next("ul")
      .stop()
      .slideToggle()
      .parent("li")
      .toggleClass("open");
  });
});
